<template>
  <button
    class="group flex items-center gap-2 w-full py-2 text-gray-700 hover:text-brand-500 h-[40px]"
    :class="collapsed ? 'justify-center' : ''"
  >
    <component
      :is="icons[icon]"
      class="h-5 w-5 text-grey-600 group-hover:text-brand-500 shrink-0"
      :class="{ 'text-brand-600': isColor }"
    />
    <span v-if="!collapsed" class="text-[14px] text-grey-light-700 group-hover:text-brand-500">{{ label }}</span>
  </button>
</template>

<script setup lang="ts">
import BoostIcon from '@/components/icons/BoostIcon.vue';
import CreditCardIcon from '@/components/icons/CreditCardIcon.vue';
import HomeIcon from '@/components/icons/HomeIcon.vue';
import PhoneColorIcon from '@/components/icons/PhoneColorIcon.vue';
import PhoneIcon from '@/components/icons/PhoneIcon.vue';
import StoreIcon from '@/components/icons/StoreIcon.vue';
import SubscriptionIcon from '@/components/icons/SubscriptionIcon.vue';
import WalletIcon from '@/components/icons/WalletIcon.vue';
import { CreditCard, HelpCircle, HelpCircleIcon, Mail, MessageCircle, Ticket, User } from 'lucide-vue-next';

defineProps<{
  label: string;
  icon: keyof typeof icons;
  collapsed?: boolean;
  isColor?: boolean;
}>();

const icons = {
  CreditCard,
  User,
  MessageCircle,
  HelpCircle,
  Ticket,
  Mail,
  HelpCircleIcon,
  Phone: PhoneIcon,
  Home: HomeIcon,
  Boost: BoostIcon,
  Subscription: SubscriptionIcon,
  Wallet: WalletIcon,
  Store: StoreIcon,
  PhoneColor: PhoneColorIcon,
  CreditCardIcon: CreditCardIcon,
};
</script>
